import IdentifiableDto from 'modules/base/dto/IdentifiableDto';

export class UzenetEditDto extends IdentifiableDto {
	constructor() {
		super();
		/** @type {number} */
		this.mentValaszIn = null;
		/** @type {string} */
		this.levelCim = null;
		/** @type {string} */
		this.tartalom = null;
		/** @type {string} */
		this.tartalomValasz = null;
		/** @type {string} */
		this.kerdesSzoveg = null;
	}

	/**
	 * @typedef {Object} _UzenetEditDtoProps
	 * @property {number} mentValaszIn
	 * @property {string} levelCim
	 * @property {string} tartalom
	 * @property {string} tartalomValasz
	 * @property {string} kerdesSzoveg
	 *
	 * @typedef {import("modules/base/dto/IdentifiableDto").IdentifiableDtoProps & _UzenetEditDtoProps} UzenetEditDtoProps
	 */
	/**
	 *
	 * @param {UzenetEditDtoProps} props
	 * @returns {UzenetEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.mentValaszIn = props.mentValaszIn;
		this.levelCim = props.levelCim;
		this.tartalom = props.tartalom;
		this.tartalomValasz = props.tartalomValasz;
		this.kerdesSzoveg = props.kerdesSzoveg;
		return this;
	}
}

export default UzenetEditDto;
